export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageQuery: string;
}

export const categories: Category[] = [
  {
    slug: 'fengshui',
    name: '开运风水',
    description: '探索风水布局的奥秘，了解家居、办公室风水调整技巧，让空间能量为您带来好运与和谐。',
    icon: 'ri-compass-3-line',
    imageQuery: 'Traditional%20Chinese%20Feng%20Shui%20compass%20and%20bagua%20mirror%20on%20silk%20fabric%20with%20soft%20warm%20lighting%2C%20elegant%20minimal%20composition%2C%20red%20and%20gold%20accents%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20high%20detail',
  },
  {
    slug: 'jewelry',
    name: '开运饰品',
    description: '精选各类开运饰品，包括水晶、玉石、生肖配饰等，为您解读每件饰品的能量与佩戴讲究。',
    icon: 'ri-vip-diamond-line',
    imageQuery: 'Elegant%20Chinese%20jade%20bracelet%20and%20crystal%20necklace%20displayed%20on%20silk%20cloth%20with%20warm%20golden%20lighting%2C%20minimal%20luxurious%20composition%2C%20cream%20background%2C%20editorial%20photography%2C%20high%20detail',
  },
  {
    slug: 'fortune',
    name: '命理测算',
    description: '了解八字命理、紫微斗数、生肖运势等传统测算方法，掌握自己的命运轨迹与发展方向。',
    icon: 'ri-calendar-check-line',
    imageQuery: 'Traditional%20Chinese%20fortune%20telling%20tools%20including%20I%20Ching%20coins%20and%20bamboo%20sticks%20on%20aged%20paper%20with%20calligraphy%2C%20warm%20amber%20lighting%2C%20minimal%20composition%2C%20cream%20background%2C%20high%20detail%20editorial',
  },
  {
    slug: 'colors',
    name: '幸运色搭配',
    description: '学习五行色彩搭配原理，掌握每日、每月幸运色，通过穿着与装饰色彩提升个人运势。',
    icon: 'ri-palette-line',
    imageQuery: 'Five%20element%20color%20palette%20with%20red%20gold%20green%20white%20black%20silk%20fabric%20swatches%20arranged%20harmoniously%2C%20warm%20natural%20lighting%2C%20minimal%20elegant%20composition%2C%20cream%20background%2C%20editorial%20style',
  },
  {
    slug: 'layout',
    name: '开运布局技巧',
    description: '掌握实用的开运布局方法，从居家摆设到办公桌布置，让每个空间都充满正能量与好运势。',
    icon: 'ri-layout-masonry-line',
    imageQuery: 'Modern%20minimalist%20living%20room%20with%20Chinese%20Feng%20Shui%20elements%20and%20lucky%20bamboo%20plant%2C%20warm%20natural%20sunlight%2C%20harmonious%20arrangement%2C%20cream%20walls%2C%20editorial%20interior%20photography%2C%20high%20detail',
  },
  {
    slug: 'lucky-items',
    name: '幸运物推荐',
    description: '为您推荐各类开运幸运物，从传统吉祥物到现代能量物品，帮助您吸引好运、驱散霉运。',
    icon: 'ri-gift-line',
    imageQuery: 'Collection%20of%20Chinese%20lucky%20charms%20including%20golden%20fortune%20cat%20and%20red%20knots%20on%20wooden%20table%2C%20soft%20natural%20lighting%2C%20minimal%20composition%2C%20cream%20background%2C%20editorial%20style%2C%20high%20detail',
  },
];